import classnames from 'classnames';
import React from 'react';

import styles from './container.module.css';

interface ContainerProps {
  fullWidth?: boolean;
  white?: boolean;
  isMobile?: boolean;
  marginBottom?: number;
  marginTop?: number;
  children: React.ReactNode;
  id?: string;
  className?: string;
  containerRef?: (node?: Element | null | undefined) => void;
}

const Container = ({
  children,
  fullWidth = false,
  white = false,
  isMobile = false,
  marginBottom = 10,
  marginTop = 0,
  id,
  className,
  containerRef,
}: ContainerProps) => {
  if (React.Children.count(children) === 0) return null;
  return (
    <div
      id={id}
      style={{ marginBottom, marginTop }}
      className={classnames(styles.container, className, {
        [styles.containerMobile]: isMobile,
        [styles.containerNotFullWidth]: !fullWidth,
        [styles.whiteBackground]: white,
      })}
      ref={containerRef}
    >
      {children}
    </div>
  );
};

export default Container;
